import { Injectable } from '@angular/core';
/**
 * Consolidated logging service to log and send data to server for further processing
 */
@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  constructor() {}
  error(error: Error) {
    console.error(`Error ocurred: ${error.message}`);
    // ToDo send data to server for processing/troubleshooting
  }
}
